import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Box, Typography, Input, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { owners, units, updatecontract } from '../../../components/Apis';
import Swal from 'sweetalert2';

const Editcontract = ({ open, contract, onClose, onSubmit, fetchContracts }) => {
  const [updatedContract, setUpdatedContract] = useState({
    id: "",
    unit_id: '',
    owner_id: '',
    profit: '',
  });
  console.log(updatedContract)

  const [uploadContract, setUploadContract] = useState(null);
  const [signedContract, setSignedContract] = useState(null);
  const [Units, setUnits] = useState([]);
  const [Owners, setOwners] = useState([]);

  useEffect(() => {
    if (contract) {
      setUpdatedContract({
        unit_id: contract.unit_id,
        id: contract.id,
        owner_id: contract.owner_id,
        profit: contract.profit,
      });
    }
    fetchUnits();
    fetchOwners();
  }, [contract]);

  const fetchUnits = async () => {
    try {
      const response = await units();
      setUnits(response);
    } catch (error) {
      console.error('Error fetching units:', error);
    }
  };

  const fetchOwners = async () => {
    try {
      const response = await owners();
      setOwners(response);
    } catch (error) {
      console.error('Error fetching owners:', error);
    }
  };

  const handleChange = (e) => {
    Swal.showLoading();

    const { name, value } = e.target;
    setUpdatedContract((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const formData = new FormData();

    if (signedContract) {
      formData.append('signed_contract', signedContract);
    }
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }
    const res = await updatecontract(formData, contract.id)
    onClose();

    console.log(res)

    if (res?.message === "Contract updated successfully.") {
      Swal.fire({
        title: "Success",
        text: "Contract updated successfully.",
        icon: "success",
        timer: 3000, // عرض الرسالة لمدة 3 ثوانٍ
        showConfirmButton: false, // إخفاء زر التأكيد
      });
      onClose();
      setTimeout(() => {
        fetchContracts()
      }, 3000)

    }
    else if (res.response?.data?.message === "The signed contract must be a file of type: pdf, doc, docx.") {
      onClose();

      Swal.fire({
        icon: "error", // لتحديد رمز الخطأ
        title: "Error",
        text: res.response.data.message || "An error occurred.",
        confirmButtonText: "OK",
      });

    }
    if (res?.message === "Request failed with status code 413") {
      Swal.fire({
        title: "Error",
        text: "Please upload a smaller image or PDF file.",
        icon: "error",
        timer: 5000, // عرض الرسالة لمدة 5 ثوانٍ
        showConfirmButton: true, // إظهار زر التأكيد
      });
      onClose();


      // fetchContracts()
    }
    // setTimeout(() => {
    //   fetchContracts()

    // }, 10000)

  };

  const handleUploadContractChange = (event) => {
    setUploadContract(event.target.files[0]);
  };

  const handleSignedContractChange = (event) => {
    setSignedContract(event.target.files[0]);
  };

  return (
    <Dialog open={open} onClose={onClose} dir="ltr">
      <DialogTitle>Edit Contract</DialogTitle>
      <DialogContent sx={{width:"25rem",height:"5rem",overflow:"hidden"}}>




        {/* Signed Contract */}
        <Box mt={2}>
          <Typography variant="body2" sx={{fontSize:"1rem"}}>Signed Contract:</Typography>
          {/* <Input
            type="file"
            accept=".pdf,.doc,.docx"
            onChange={handleSignedContractChange}
            fullWidth
          /> */}
          <Button
            component="span"
            sx={{
              backgroundColor: "#a0553a",
              marginTop:"5px",
              color: "white",
              "&:hover": {
                backgroundColor: "#a0553a",
              }
            }}
          >
            Choose Files
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              multiple
              onChange={handleSignedContractChange}
              hidden
            />
          </Button>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}
          sx={{
            mt: 2,
            padding: "10px",
            borderRadius: "8px",
            fontWeight: "bold",
            backgroundColor: "#a0553a",
            color: "white",
            "&:hover": {
              backgroundColor: "#a0553a",
              color: "white",
            },
          }}
        >Cancel</Button>
        <Button
          onClick={handleSubmit}
          disabled={!updatedContract.unit_id || !updatedContract.owner_id || !updatedContract.profit}
          sx={{
            mt: 2,
            padding: "10px",
            borderRadius: "8px",
            fontWeight: "bold",
            backgroundColor: "#a0553a",
            color: "white",
            "&:hover": {
              backgroundColor: "#a0553a",
              color: "white",
            },
          }}
        >
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Editcontract;
